import {
  SET_GAME_INFORMATION,
  SET_PLAYER_COUNT,
  SET_PLAYER_SORT_TYPE,
  SET_PLAYER_POSITION_FILTER,
  SET_MAINPAGE_VIEW,
  SET_SELECTED_PLAYER_STATS,
  SET_DISPLAY_PLAYERS,
  SET_GOBACK_BOOLEAN,
  SET_TEAMNAME_SELECTED_PLAYER,
  SET_TIME_HOURS,
  SET_TIME_MINUTES,
  SET_TIME_SECONDS,
  SET_MATCH_DATETIME,
  SET_PL_RES,
  SET_PLAYER_SEARCHED_NAME,
  SET_GAME_TEAMS,
  SET_TEAM_FILTER,
  SET_API_FLAG,
  SET_LEAGUE,
  SET_COMPLETE_GAME_INFORMATION,
  SET_SLATE_ID,
  SET_SELECTED_TIMEFRAME,
  SET_AVAILABLE_TIMEFRAMES,
  SET_AUTO_LINEUP_GEN_BAR_OPEN_FLAG,
  SET_IN_MEMORY_TIMEFRAMES,
  SET_HORIZONTAL_SCROLL_POSITION,
  SET_PL_STATUS,
  SET_PLAYER_LOCKED_COUNT,
  SET_PLAYER_FAVOURITE_COUNT,
  SET_PLAYER_EXCLUDED_COUNT,
  SET_PLAYER_LFD_COUNT,
  SET_IS_RESET_CLICKED,
  UPDATE_PLAYER_LFD_FLAG,
  SIGNOUT_REQUEST,
  DATA_REQUEST,
  DATA_SUCCESS,
  DATA_ERROR,
} from "./GameInformation";

import {
  vbDateSlateArray,
  vbDateGameDateTimeInfo,
} from "../../utils/scheduleInfo";
import { API_CONSTANTS } from "../../utils/constantInformation";
import { REHYDRATE } from "redux-persist/lib/constants";
import storage from "redux-persist/lib/storage";

if (
  process.env.REACT_APP_ENV === "production"
  // || process.env.REACT_APP_ENV === "development"
) {
  console.log = () => {};
  console.groupCollapsed = () => {};
  console.groupEnd = () => {};
  console.error = () => {};
}

let date_today = new Date();
let month = parseInt(date_today.getMonth() + 1);
let formattedMonth = month.toLocaleString("en-US", {
  minimumIntegerDigits: 2,
  useGrouping: false,
});
// console.log("month-formatted month");
// console.log(month, formattedMonth);
let date_str =
  date_today.getFullYear() + "-" + formattedMonth + "-" + date_today.getDate();
// "2021-06-22";
// *** TODO: Uncomment these both lines when season is live ***
let slate = null;
let scheduleDatetime = null;
let noMatchToday = true;
console.log("psl today", vbDateSlateArray[date_str]);
if (typeof vbDateSlateArray[date_str] !== typeof undefined) {
  console.log(typeof vbDateSlateArray[date_str]);
  slate = vbDateSlateArray[date_str][0];
  scheduleDatetime = vbDateGameDateTimeInfo[date_str][0];
  noMatchToday = false;
}

console.log("Current Date: ", date_str);
console.log("Current Slate: ", slate);
console.log("Current scheduleDatetime: ", scheduleDatetime);

export const initial_information = {
  complete_game_information: null,
  platform: "dream11",
  // sports: "IPL",
  // sports: "VB",
  sports: null,
  // selected_timeframe: "2021-05-4", // @RTailor make this dynamic [today's date when season is live] replace it with - date_str
  selected_timeframe: date_str, // @RTailor make this dynamic [today's date when season is live] replace it with - date_str
  // slate_id: "20210504SRHMI11", // TODO : replace it with - slate
  slate_id: slate, // TODO : replace it with - slate
  player_counts: 0,
  time_hours: 0,
  time_minutes: 0,
  time_seconds: 0,
  player_sort_type: "OperatorPlayerCredits",
  player_sort_order: "DESC",
  player_position_filter: "ALL",
  view_selected: "default_page",
  selected_player_stats: null,
  display_players: [],
  go_back_boolean: false,
  selected_player_teamname: null,
  // match_datetime: "2021-05-04T19:30:00+05:30", // @RTailor make this dynamic, get time information from db initially like slateArray, TODO: replace it with - scheduleDatetime
  match_datetime: scheduleDatetime, // @RTailor make this dynamic, get time information from db initially like slateArray, TODO: replace it with - scheduleDatetime
  pl_res: "P",
  player_status: API_CONSTANTS.NULL_CONSTANT,

  player_searched_name: "",
  game_teams: [],
  filtered_team: "Both",
  got_api_data: false,
  available_timeframes: [],
  no_match_today: noMatchToday,
  auto_lineup_gen_bar_open_flag: false,
  in_memory_timeframe: [],
  horizontal_scroll_position: 0,
  slate_locked_player_count: 0,
  slate_favourite_player_count: 0,
  slate_excluded_player_count: 0,
  slate_lfd_count: {
    locked: 0,
    favourite: 0,
    excluded: 0,
  },
  is_reset_clicked: false,
  loading: false,
  error: null,
};
// const initial_information = {
//   platform: "dream11",
//   sports: "IPL",
//   selected_timeframe: "2021-05-4", // @RTailor make this dynamic [today's date when season is live]
//   slate_id: "20210504SRHMI11",
//   player_counts: 0,
//   time_hours: 0,
//   time_minutes: 0,
//   time_seconds: 0,
//   player_sort_type: "OperatorPlayerCredits",
//   player_sort_order: "DESC",
//   player_position_filter: "ALL",
//   view_selected: "default_page",
//   selected_player_stats: null,
//   display_players: [],
//   go_back_boolean: false,
//   selected_player_teamname: null,
//   match_datetime: "2021-05-04T19:30:00+05:30",
//   pl_res: "PLYR",
//   player_searched_name: "",
//   game_teams: [],
//   filtered_team: "Both",
//   got_api_data: false,
// };

const gameInformationReducer = (state = initial_information, action) => {
  console.log("###############  GameInfo Reducer  ###############");
  console.log("Action: ", action);
  console.log("State: ", state);
  switch (action.type) {
    case SIGNOUT_REQUEST:
      // for all keys defined in your persistConfig(s)
      storage.removeItem("persist:root");
      // storage.removeItem('persist:otherKey')
      // return gameInformationReducer(undefined, action);
      return initial_information;

    case REHYDRATE: {
      console.log("REHYDRATEconstants");
      return { ...state };
    }
    case UPDATE_PLAYER_LFD_FLAG: {
      const currentDisplayPlayerList = state.display_players.slice();
      console.log("action:: update_player_lfd:: ", action);
      currentDisplayPlayerList.forEach((player) => {
        if (player.OperatorPlayerID === action.action.operator_player_id) {
          player.locked = action.action.locked;
          player.favourite = action.action.favourite;
          player.excluded = action.action.excluded;
        }
      });
      return { ...state, display_players: currentDisplayPlayerList };
    }
    case SET_IS_RESET_CLICKED:
      return {
        ...state,
        is_reset_clicked: action.is_reset_clicked,
      };
    case SET_PLAYER_LFD_COUNT:
      return {
        ...state,
        slate_lfd_count: action.slate_lfd_count,
      };
    case SET_PLAYER_LOCKED_COUNT:
      return {
        ...state,
        slate_locked_player_count: action.slate_locked_player_count,
      };
    case SET_PLAYER_FAVOURITE_COUNT:
      return {
        ...state,
        slate_favourite_player_count: action.slate_favourite_player_count,
      };
    case SET_PLAYER_EXCLUDED_COUNT:
      return {
        ...state,
        slate_excluded_player_count: action.slate_excluded_player_count,
      };
    case SET_PL_STATUS:
      return {
        ...state,
        player_status: action.player_status,
      };
    case SET_HORIZONTAL_SCROLL_POSITION:
      return {
        ...state,
        horizontal_scroll_position: action.horizontal_scroll_position,
      };
    case SET_IN_MEMORY_TIMEFRAMES:
      return {
        ...state,
        in_memory_timeframe: action.in_memory_timeframe,
      };
    case SET_AVAILABLE_TIMEFRAMES:
      return {
        ...state,
        available_timeframe: action.available_timeframes,
      };
    case SET_SELECTED_TIMEFRAME:
      return {
        ...state,
        selected_timeframe: action.selected_timeframe,
      };
    case SET_SLATE_ID:
      return {
        ...state,
        slate_id: action.slate_id,
      };
    case SET_COMPLETE_GAME_INFORMATION:
      return {
        ...state,
        complete_game_information: action.complete_game_information,
      };
    case SET_LEAGUE:
      return {
        ...state,
        sports: action.sports,
      };
    case SET_AUTO_LINEUP_GEN_BAR_OPEN_FLAG:
      return {
        ...state,
        auto_lineup_gen_bar_open_flag: action.auto_lineup_gen_bar_open_flag,
      };
    case SET_API_FLAG:
      return {
        ...state,
        got_api_data: action.got_api_data,
      };
    case SET_TEAM_FILTER:
      return {
        ...state,
        filtered_team: action.filtered_team,
      };
    case SET_GAME_TEAMS:
      return {
        ...state,
        game_teams: action.game_teams,
      };

    case SET_PLAYER_SEARCHED_NAME:
      return {
        ...state,
        player_searched_name: action.player_searched_name,
      };

    case SET_GAME_INFORMATION:
      return {
        ...state,
        platform: action.platform,
        sports: action.sports,
        selected_timeframe: action.selected_timeframe,
        slate_id: action.slate_id,
      };

    case SET_PLAYER_COUNT:
      return {
        ...state,
        player_counts: action.player_counts,
      };
    case SET_TIME_HOURS:
      return {
        ...state,
        time_hours: action.time_hours,
      };
    case SET_TIME_MINUTES:
      return {
        ...state,
        time_minutes: action.time_minutes,
      };
    case SET_TIME_SECONDS:
      return {
        ...state,
        time_seconds: action.time_seconds,
      };
    case SET_MATCH_DATETIME:
      return {
        ...state,
        match_datetime: action.match_datetime,
      };
    case SET_PLAYER_SORT_TYPE:
      return {
        ...state,
        player_sort_type: action.player_sort_type,
        player_sort_order: action.player_sort_order,
      };
    case SET_PLAYER_POSITION_FILTER:
      return {
        ...state,
        player_position_filter: action.player_position_filter,
      };
    case SET_MAINPAGE_VIEW:
      return {
        ...state,
        view_selected: action.view_selected,
        goto_main_page: action.goto_main_page,
      };
    case SET_SELECTED_PLAYER_STATS:
      return {
        ...state,
        selected_player_stats: action.selected_player_stats,
      };
    case SET_DISPLAY_PLAYERS:
      console.log("SET_DISPLAY_PLAYERS", action);
      return {
        ...state,
        display_players: action.display_players,
      };

    // Experimental Changes

    // case SET_ONE_DISPLAY_PLAYER:
    //     console.log("SET_ONE_DISPLAY_PLAYERS", action);
    //     return {
    //       ...state,
    //       display_players: action.display_players,
    //     };
    case SET_GOBACK_BOOLEAN:
      return {
        ...state,
        go_back_boolean: action.go_back_boolean,
      };

    case SET_TEAMNAME_SELECTED_PLAYER:
      return {
        ...state,
        selected_player_teamname: action.selected_player_teamname,
      };

    case SET_PL_RES:
      return {
        ...state,
        pl_res: action.pl_res,
      };
    case DATA_REQUEST:
      console.log("DATA_REQUEST action");
      return { ...state, loading: true, error: null };
    case DATA_SUCCESS:
      return { ...state, loading: false, error: null };
    case DATA_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default gameInformationReducer;
